import React, { useEffect } from 'react';
import Typography from '@mui/material/Typography';
import * as _R from 'ramda';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import { TaskFilterComponent } from './TaskFilterComponent';
import { DialogBoxMedium } from '../../common/dialog.medium';
import { CustomMaterialTable } from '../../common/CustomMaterialTable';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import Autocomplete from '@mui/material/Autocomplete';
import { CustomizedSnackbars } from '../../common/snackbars';
import Drawer from '@mui/material/Drawer';
import FilterListIcon from '@mui/icons-material/FilterList';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import TextField from '@mui/material/TextField';


export const UserMapDetailsComponent = (props) => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    return (
        <>
            <div style={{ marginBottom: '10px' }}>
                <Button
                    size="small"
                    variant="outlined"
                    className="startIcon-noMargin"
                    startIcon={
                        <Tooltip title="Back" aria-label="back">
                            <ChevronLeftIcon />
                        </Tooltip>
                    }
                    onClick={() => {
                        window.history.back();
                    }}
                />
            </div>
            <Paper  sx={{ p: 3, mt: 2}}>      
                <div className={'section-main'}>
                    <div className={'section-header'}>
                        <div className={'col-left'}>
                            <div className="section-title-wrap">
                            <div style={{ marginBottom: '12px' }}>
                                <Typography  component="h2" className={'section-title'} variant="button" display="block" gutterBottom color="primary">{props.DestinationInstance} Instance </Typography>
                                </div>
                                <Typography display="block" style={{ marginBottom: '20px' }}>
                                    Task Mapping Details :
                                    <span color="primary"> {props.SrcFullName}</span>
                                </Typography>
                                <Grid item xs={12} md={12} className='justify-between'>
                                    <FormControl variant="standard" fullWidth>
                                        <Autocomplete
                                            value={
                                                props.UserMappedList?.find(
                                                    x => x.id == props.selectedUser
                                                ) || null
                                            }
                                            onChange={(e, newValue) => {
                                                props.HandleUserChange({
                                                    target: {
                                                        name: "selectedUser",
                                                        value: newValue ? newValue.id : ""
                                                    }
                                                });
                                            }}
                                            options={props.UserMappedList || []}
                                            getOptionLabel={(option) =>
                                                option ? `${option.src_full_name}` : ""
                                            }
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    variant="standard"
                                                    label="User"
                                                    required
                                                />
                                            )}
                                            noOptionsText="No matching users"
                                        />
                                    </FormControl>
                                </Grid>
                            </div>
                        </div>
                        <div className={'action'}>
                            {props.StaffEdit && (
                                <Button
                                    variant="contained"
                                    size="small"
                                    color="primary"
                                    onClick={() => { props.HandleAddTaskClick() }}
                                >
                                    Add
                                </Button>
                            )}
                            <Tooltip title="Filter">
                                <IconButton
                                    onClick={props.FilterView('right', true)}
                                >
                                    <FilterListIcon color="action" />
                                </IconButton>
                            </Tooltip>
                            <Drawer
                                open={props.FilterViewState}
                                anchor={'right'}
                                onClose={props.FilterView('right', false)}
                            >
                                <div className={'tree-view-drawer'}>
                                    <div className={'drawer-title'}>Filter</div>
                                    <TaskFilterComponent
                                        FilterStatus={props.FilterStatus}
                                        handleOnSubmit={props.FilterSubmit}
                                        HandleOnChange={props.HandleOnChange}
                                    />
                                </div>
                            </Drawer>
                        </div>
                        {props.StaffView &&
                            <form className="form-fullwidth" method="post">
                                <React.Fragment>
                                    <div className={'mtable-basic'}>
                                        <CustomMaterialTable
                                            title=" "
                                            columns={[
                                                {
                                                    title: 'Source Task',
                                                    field: 'src_task_path',
                                                    width: "40%",
                                                    render: rowData => <>{rowData.src_task_path + ' (' + rowData.src_task_status_name + ')'}</>
                                                },
                                                {
                                                    title: 'Destination Task',
                                                    field: 'dest_task_path',
                                                    width: "40%",
                                                    render: rowData => <>{rowData.dest_task_path + ' (' + rowData.dest_task_status_name + ')'}</>
                                                },
                                                {
                                                    title: 'Sync Status',
                                                    field: 'status',
                                                    width: "15%",
                                                    render: rowData => <>{rowData.status === 1 ? "Active" : "Inactive"}</>

                                                },
                                            ]}
                                            data={props.SyncTaskList}
                                            options={{
                                                search: false,
                                                actionsColumnIndex: -1,
                                                toolbar: true,
                                                pageSizeOptions: [10, 20, 30],
                                                rowStyle: rowData => ({
                                                    color: (typeof rowData.isDataChanged !== 'undefined' && rowData.isDataChanged) ? '#DC143C' : '',
                                                })
                                            }}
                                            actions={props.StaffEdit ? [
                                                {
                                                    icon: 'edit',
                                                    tooltip: 'Edit',
                                                    onClick: (event, rowData) => {
                                                        props.HandleEditClick(rowData.id, rowData.user_map_id, rowData.status, rowData.src_task_id, rowData.dest_task_id, rowData.src_task_path, rowData.dest_task_path);
                                                    },
                                                },


                                            ] : []}
                                        />
                                    </div>
                                </React.Fragment>
                            </form>

                        }

                    </div>
                </div>
            </Paper>
            {props.SnackbarOpen &&
                <CustomizedSnackbars
                    open={props.SnackbarOpen}
                    variant={props.SnackbarVariant}
                    message={props.SnackbarMsg}
                    handleClose={props.SnackbarClose}
                />
            }
            {props.Open &&
                <DialogBoxMedium
                    Open={props.Open}
                    Cancel={props.Close}
                    Title={`Edit Task Mapping - ${props.SrcFullName}`}
                    OnSubmit={() => props.OnSave(props.EditId, props.EditStatus)}
                    Content={<DialogContent FormProps={props} />}
                />
            }
            {props.AddOpen &&
                <DialogBoxMedium
                    Open={props.AddOpen}
                    Cancel={props.Close}
                    Title={`Add Task Mapping - ${props.SrcFullName}`}
                    OnSubmit={() => props.OnAddSubmit('task')}
                    Content={<AddDialogContent FormProps={props} />}
                />
            }            
        </>
    )
}
const DialogContent = (p) => {
    const { FormProps: props } = p;
    return (
        <form className="form-fullwidth">
            <Typography style={{ marginBottom: '16px' }}>Destination User - {props.DestinationFullName}  ({props.DestinationInstance})</Typography>
            <Grid item xs={12} md={12} className='justify-between'>
                <FormControl variant="standard" fullWidth>
                    <Autocomplete
                        value={
                            props.EditSrcTaskList?.find(
                                x => x.task_id === props.FormFields.editSrcTask
                            ) || null
                        }
                        onChange={(e, newValue) => {
                            props.HandleOnChange({
                                target: {
                                    name: "editSrcTask",
                                    value: newValue ? newValue.task_id : ""
                                }
                            });
                        }}
                        options={props.EditSrcTaskList || []}
                        getOptionLabel={(option) =>
                            option ? `${option.task_path} (${option.task_status_name})` : ""
                        }
                        getOptionDisabled={(option) => option.task_status_name !== "Active"}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                variant="standard"
                                label="Source Task"
                                required
                            error={Boolean(props.Errors?.editSrcTask)}
                            helperText={props.Errors?.editSrcTask || ""}
                            />
                        )}
                        noOptionsText="No matching task"
                    />
                </FormControl>
            </Grid>

            <Grid item xs={12} md={12} className='justify-between'>
                <FormControl variant="standard" fullWidth>
                    <Autocomplete
                        value={
                            props.EditDestTaskList?.find(
                                x => x.task_id === props.FormFields.editDestTask
                            ) || null
                        }
                        onChange={(e, newValue) => {
                            props.HandleOnChange({
                                target: {
                                    name: "editDestTask",
                                    value: newValue ? newValue.task_id : ""
                                }
                            });
                        }}
                        options={props.EditDestTaskList || []}
                        getOptionLabel={(option) =>
                            option ? `${option.task_path} (${option.task_status_name})` : ""
                        }
                        getOptionDisabled={(option) => option.task_status_name !== "Active"}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                variant="standard"
                                label="Destination Task"
                                required
                                error={Boolean(props.Errors?.editDestTask)}
                                helperText={props.Errors?.editDestTask || ""}
                            />
                        )}
                        noOptionsText="No matching task"
                    />
                </FormControl>
            </Grid>

            <Grid item xs={12} md={12}>
                <FormControl variant="standard">
                    <InputLabel htmlFor="status">Sync Status</InputLabel>
                    <Select
                        value={props.EditStatus} onChange={props.HandleStatusChange}
                        inputProps={{
                            name: 'status',
                            id: 'status',
                        }}>
                        <MenuItem value={1}>Active</MenuItem>
                        <MenuItem value={0}>Inactive</MenuItem>
                    </Select>
                </FormControl>
            </Grid>
        </form>
    )
}
const AddDialogContent = (p) => {
    const { FormProps: props } = p;
    return (
        <form className="form-fullwidth">
            <Typography style={{ marginBottom: '16px' }}>Destination User - {props.DestinationFullName}  ({props.DestinationInstance})</Typography>
            <Grid item xs={12} md={12} className='justify-between'>
                <FormControl variant="standard" fullWidth>
                    <Autocomplete
                        value={
                            props.SrcAddTaskList?.find(x => x.task_id === props.FormFields.addSrcTask) || null
                        }
                        onChange={(e, newValue) => {
                            props.HandleOnChange({
                                target: {
                                    name: "addSrcTask",
                                    value: newValue ? newValue.task_id : ""
                                }
                            });
                        }}
                        options={props.SrcAddTaskList || []}
                        getOptionLabel={(option) =>
                            option ? `${option.task_path} (${option.task_status_name})` : ""
                        }
                        getOptionDisabled={(option) => option.task_status_name !== "Active"}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                variant="standard"
                                required
                                label="Source Task"
                                error={Boolean(props.Errors?.addSrcTask)}
                                helperText={props.Errors?.addSrcTask || ""}
                            />
                        )}
                        noOptionsText="No matching task"
                    />
                </FormControl>
            </Grid>

            <Grid item xs={12} md={12} className='justify-between'>
                <FormControl variant="standard" fullWidth>
                    <Autocomplete
                        value={
                            props.DestinationAddTaskList?.find(
                                x => x.task_id === props.FormFields.addDestTask
                            ) || null
                        }
                        onChange={(e, newValue) => {
                            props.HandleOnChange({
                                target: {
                                    name: "addDestTask",
                                    value: newValue ? newValue.task_id : ""
                                }
                            });
                        }}
                        options={props.DestinationAddTaskList || []}
                        getOptionLabel={(option) =>
                            option ? `${option.task_path} (${option.task_status_name})` : ""
                        }
                        getOptionDisabled={(option) => option.task_status_name !== "Active"}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                variant="standard"
                                label="Destination Task"
                                required
                                error={Boolean(props.Errors?.addDestTask)}
                                helperText={props.Errors?.addDestTask || ""}
                            />
                        )}
                        noOptionsText="No matching task"
                    />
                </FormControl>

            </Grid>
            <Grid item xs={12} md={12}>
                <FormControl variant="standard">
                    <InputLabel htmlFor="status">Sync Status</InputLabel>
                    <Select
                        value={props.AddStatus} onChange={props.HandleAddStatusChange}
                        inputProps={{
                            name: 'add_status',
                            id: 'add_status',
                        }}>
                        <MenuItem value={1}>Active</MenuItem>
                        <MenuItem value={0}>Inactive</MenuItem>
                    </Select>
                </FormControl>
            </Grid>
        </form>
    )
}